import {
  iHolidayQuoteContentBlocks,
  iHolidayQuoteX,
} from "@/@sdk/holiday-quotes-x/holiday-quotes-x-model";

function isDayByDay(block: iHolidayQuoteContentBlocks) {
  return block.type === "day_by_day_itinerary";
}

/**
 * Brochure Mode content zones.
 * Day-by-day blocks stay in their original section (usually before itinerary);
 * they are listed separately only for sticky-nav detection.
 */
export function partitionContentForTripMode(quote: iHolidayQuoteX) {
  const preItineraryBlocks = quote.preItineraryBlocks ?? [];
  const postItineraryBlocks = quote.postItineraryBlocks ?? [];
  const pricingBlocks = quote.pricingBlocks ?? [];
  const postPricingBlocks = quote.postPricingBlocks ?? [];

  const dayByDayBlocks = [
    ...preItineraryBlocks,
    ...postItineraryBlocks,
    ...pricingBlocks,
    ...postPricingBlocks,
  ].filter(isDayByDay);

  return {
    dayByDayBlocks,
    preItineraryBlocks,
    postItineraryBlocks,
    pricingBlocks,
    postPricingBlocks,
  };
}
